<template>
  <div
    :class="['vcenter splash-page', config.options.imageDisplay]"
    style="height: 100%"
  >
    <div class="bg-wrap" :style="backgroundStyles()">
      <video
        v-if="config.options.backgroundVideo"
        autoplay
        muted
        loop
        id="background-video"
        :poster="config.options.videoPoster"
      >
        <source
          v-for="source in config.options.backgroundVideo"
          :src="source"
          :type="contentType(source)"
        />
      </video>
      <div class="splash-logo-alt"></div>
      <div class="lang-select" v-if="$store.getters.multilingual">
        <select v-model="currentLanguage">
          <option
            :key="lang.value"
            :value="lang.value"
            v-for="lang in $store.state.supportedLanguages"
            >{{ lang.label }}</option
          >
        </select>
      </div>
      <div
        :id="cssId(config.options)"
        :class="cssClass('splash', config.options)"
      >
        <div
          class="column column--image"
          v-if="this.config.options.imageDisplay == 'logo'"
        >
          <div class="splash-image">
            <img :src="this.config.options.image" alt="" />
          </div>
        </div>
        <div class="column column--text" :style="textStyles">
          <div class="splash-content">
            <div class="splash-logo"></div>
            <transition v-on:before-appear="beforeEnter" name="fade" appear>
              <header
                data-appear="500"
                v-show="showHeader"
                :style="headingStyle"
              >
                <h1 v-html="$t(config.options.title, 'options.title')"></h1>
              </header>
            </transition>
            <section class="intro" :style="introStyle">
              <transition v-on:before-appear="beforeEnter" name="fade" appear>
                <p
                  v-show="showIntro"
                  data-appear="1000"
                  v-html="
                    $t(config.options.introduction, 'options.introduction')
                  "
                ></p>
              </transition>
              <transition v-on:before-appear="beforeEnter" name="fade" appear>
                <div
                  data-appear="1500"
                  :class="['slider-wrap', sliderClasses]"
                  v-show="showSlider"
                >
                  <transition
                    v-on:before-appear="beforeEnter"
                    name="fade"
                    appear
                  >
                    <p data-appear="2000">
                      Can your IT team support employees remotely and in real time?
                    </p>
                  </transition>
                  <transition
                    v-on:before-appear="beforeEnter"
                    name="fade"
                    appear
                  >
                    <div data-appear="3000" v-if="hideMe" class="slider-help">
                      <p>&lt;drag to start&gt;</p>
                    </div>
                  </transition>
                  <vue-slider
                    v-model="sliderValue"
                    :tooltip="'none'"
                    :height="20"
                    :dotSize="100"
                    :marks="{
                      '0': 'Rarely',
                      '100': 'Always'
                    }"
                  ></vue-slider>
                </div>
              </transition>
            </section>
            <transition v-on:before-appear="beforeEnter" name="fade">
              <div v-if="showButton">
                <a
                  tabindex="2"
                  role="button"
                  class="button"
                  @mouseenter="addHover()"
                  @mouseleave="removeHover()"
                  :style="buttonStyles"
                  v-on:keyup.enter.once="advance"
                  @click.once="advance"
                  >{{ $t(config.options.buttonText, "options.buttonText") }}</a
                >
                <p
                  class="small-print"
                  :style="introStyle"
                  v-if="config.options.optinTextEnabled"
                  v-html="$t(config.options.optinText, 'options.optinText')"
                ></p>
              </div>
            </transition>
          </div>
        </div>
      </div>
      <a
        href="https://cogniclick.com"
        target="_blank"
        class="powered-by powered-splash p-desktop"
      >
        <span class="power-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35">
            <g opacity=".7">
              <path
                d="M22 20.9c-1 1.4-2.7 2.3-4.5 2.3-3.1 0-5.7-2.6-5.7-5.7s2.6-5.7 5.7-5.7c1.9 0 3.6 1 4.6 2.4l2.1-1.1c-1.4-2.2-3.9-3.7-6.8-3.7-4.4 0-8 3.6-8 8s3.6 8 8 8c2.8 0 5.2-1.4 6.7-3.5l-2.1-1zM20.9 25.9v1c0 1.9-1.5 3.4-3.4 3.4s-3.4-1.5-3.4-3.4v-1c.5.2 1.1.4 1.7.5v.5c0 .9.8 1.7 1.7 1.7s1.7-.8 1.7-1.7v-.5c.6-.1 1.1-.2 1.7-.5z"
              />
              <path
                d="M27.7 17c0-.2-.1-.3-.3-.3h-2.7c-.1 0-.1-.1-.1-.1V15c0-.2-.1-.3-.3-.2L19 17.5c-.2.1-.2.2 0 .3l5.3 2.7c.2.1.3 0 .3-.2v-1-.5c0-.1.1-.2.1-.2h2.7c.2 0 .3-.1.3-.3V17zM25.4 11.5l1.6-1c.4-.2.5-.8.3-1.2-.3-.4-.8-.5-1.2-.3l-1.6 1c-.4.2-.5.8-.3 1.2.2.3.4.4.7.4.2 0 .3-.1.5-.1zM21.3 8.3l.6-1.8c.1-.4-.1-.9-.6-1-.4-.1-.9.1-1 .6l-.6 1.8c-.1.4.1.9.6 1h.2c.3 0 .6-.3.8-.6z"
              />
              <g>
                <path
                  d="M10.8 11.2c.2-.4.1-.9-.3-1.2L8.9 9c-.4-.2-.9-.1-1.2.3-.2.4-.1.9.3 1.1l1.6 1c.1.1.3.1.4.1.4.1.6-.1.8-.3zM14.8 8.8c.4-.1.7-.6.6-1L14.8 6c-.1-.4-.6-.7-1-.6-.4.1-.7.6-.6 1l.6 1.8c.1.4.4.6.8.6 0 .1.1.1.2 0z"
                />
              </g>
            </g>
          </svg>
        </span>
        <span class="power-text"
          >Powered by <strong>CogniClick.com</strong></span
        >
      </a>
      <div
        @click="togglePoweredBy"
        :class="[
          'powered-by powered-splash p-mobile',
          showPoweredBy ? 'powered-by--open' : ''
        ]"
      >
        <span class="power-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35">
            <g opacity=".7">
              <path
                d="M22 20.9c-1 1.4-2.7 2.3-4.5 2.3-3.1 0-5.7-2.6-5.7-5.7s2.6-5.7 5.7-5.7c1.9 0 3.6 1 4.6 2.4l2.1-1.1c-1.4-2.2-3.9-3.7-6.8-3.7-4.4 0-8 3.6-8 8s3.6 8 8 8c2.8 0 5.2-1.4 6.7-3.5l-2.1-1zM20.9 25.9v1c0 1.9-1.5 3.4-3.4 3.4s-3.4-1.5-3.4-3.4v-1c.5.2 1.1.4 1.7.5v.5c0 .9.8 1.7 1.7 1.7s1.7-.8 1.7-1.7v-.5c.6-.1 1.1-.2 1.7-.5z"
              />
              <path
                d="M27.7 17c0-.2-.1-.3-.3-.3h-2.7c-.1 0-.1-.1-.1-.1V15c0-.2-.1-.3-.3-.2L19 17.5c-.2.1-.2.2 0 .3l5.3 2.7c.2.1.3 0 .3-.2v-1-.5c0-.1.1-.2.1-.2h2.7c.2 0 .3-.1.3-.3V17zM25.4 11.5l1.6-1c.4-.2.5-.8.3-1.2-.3-.4-.8-.5-1.2-.3l-1.6 1c-.4.2-.5.8-.3 1.2.2.3.4.4.7.4.2 0 .3-.1.5-.1zM21.3 8.3l.6-1.8c.1-.4-.1-.9-.6-1-.4-.1-.9.1-1 .6l-.6 1.8c-.1.4.1.9.6 1h.2c.3 0 .6-.3.8-.6z"
              />
              <g>
                <path
                  d="M10.8 11.2c.2-.4.1-.9-.3-1.2L8.9 9c-.4-.2-.9-.1-1.2.3-.2.4-.1.9.3 1.1l1.6 1c.1.1.3.1.4.1.4.1.6-.1.8-.3zM14.8 8.8c.4-.1.7-.6.6-1L14.8 6c-.1-.4-.6-.7-1-.6-.4.1-.7.6-.6 1l.6 1.8c.1.4.4.6.8.6 0 .1.1.1.2 0z"
                />
              </g>
            </g>
          </svg>
        </span>
        <span class="power-text"
          ><a href="https://cogniclick.com" target="_blank"
            >Powered by <strong>CogniClick.com</strong></a
          ></span
        >
      </div>
    </div>
  </div>
</template>

<script>
import chroma from "chroma-js";
import Velocity from "velocity-animate";
import TranslationMixin from "../lib/TranslationMixin";
import VueSlider from "vue-slider-component";
import Vue from "vue";
import "vue-slider-component/theme/default.css";

export default {
  name: "SplashPage",
  mixins: [TranslationMixin],
  data() {
    return {
      buttonStyles: {},
      showPoweredBy: false,
      sliderValue: 50,
      showHeader: true,
      showIntro: true,
      showSlider: true,
      showButton: false,
      hideMe: true
    };
  },
  props: ["config", "index"],
  inject: ["theme"],
  components: {
    VueSlider
  },
  computed: {
    textStyles() {
      let color = this.config.options.textColor || this.theme.secondary.color;
      return { color: color };
    },
    headingStyle() {
      return {
        fontSize: this.config.options.titleSize + "%"
      };
    },
    sliderClasses() {
      return this.sliderValue <= 49 ? "thumbdown" : "thumbup";
    },
    introStyle() {
      return {
        fontSize: this.config.options.textSize + "%"
      };
    },
    signup: function() {
      return this.$store.state.config.signup;
    },
    variant: function() {
      return this.$store.state.urlParams.cv;
    },
    currentLanguage: {
      get() {
        return this.$store.state.language;
      },
      set(lang) {
        this.$store.commit("setLanguage", lang);
      }
    }
  },
  methods: {
    beforeEnter: function(el, done) {
      Velocity(
        el,
        { opacity: 0, translateY: "100%", translateZ: 0 },
        { duration: 0 }
      );
      const delay = Number(el.dataset.appear);
      setTimeout(function() {
        Velocity(
          el,
          { opacity: 1, translateY: "0%", translateZ: 0 },
          { complete: done, duration: 550 }
        );
      }, delay);
    },
    saveAnswer(key, value, score = 0) {
      this.$store.dispatch("save", {
        key: key,
        answer: { value: value, score: score }
      });
    },
    async getData() {
      await this.$store.dispatch("start");
    },
    contentType(source) {
      let rx = /.+\.(.*)$/;
      return "video/" + source.match(rx)[1];
    },
    togglePoweredBy() {
      this.showPoweredBy = !this.showPoweredBy;
    },
    advance() {
      this.$gtag.event("survey", {
        event_category: "start",
        event_label: "started",
        value: 1
      });
      this.$store.dispatch("start").then(() => {
        this.$store.dispatch("saveLanguage").then(() => {
          this.saveAnswer("splash-slider", this.sliderValue, this.sliderValue);
          this.$store.commit("advance");
        });
      });
    },
    addHover(event) {
      this.buttonStyles = Object.assign({}, this.hoverButtonStyles);
    },
    removeHover(event) {
      this.buttonStyles = Object.assign({}, this.baseButtonStyles);
    },
    backgroundStyles() {
      let bgColor =
        this.config.options.backgroundColor ||
        this.theme.secondary.backgroundColor;
      let styles = {
        backgroundColor: bgColor,
        width: "100%",
        height: "100%",
        minHeight: "100vh"
      };
      if (
        typeof this.config.options.image !== "undefined" &&
        this.config.options.image &&
        this.config.options.imageDisplay === "full"
      ) {
        styles.backgroundImage = `url('${this.config.options.image}')`;
      }
      return styles;
    }
  },
  mounted() {
    this.animateIn("showHeader", 1000);
    this.animateIn("showIntro", 2000);
    this.animateIn("showSlider", 3000);
  },
  created() {
    this.getData();
    this.baseButtonStyles = {
      backgroundColor:
        this.config.options.buttonColor || this.theme.accent.backgroundColor,
      color: this.config.options.buttonTextColor || this.theme.accent.color
    };
    this.baseButtonStyles.borderRadius = this.theme.borderRadius + "px";
    let hoverColor = chroma(this.baseButtonStyles.color)
      .darken()
      .hex();
    let hoverBackgroundColor = chroma(this.baseButtonStyles.backgroundColor)
      .darken()
      .hex();
    let hoverStyle = {
      color: hoverColor,
      backgroundColor: hoverBackgroundColor
    };
    hoverStyle.borderRadius = this.theme.borderRadius + "px";
    this.hoverButtonStyles = hoverStyle;
    this.buttonStyles = Object.assign({}, this.baseButtonStyles);

    this.animateIn = (target, delay) => {
      setTimeout(() => Vue.set(this, target, true), delay);
    };
  },
  watch: {
    sliderValue: function(val, old) {
      this.showButton = true;
      this.hideMe = false;
    }
  }
};
</script>

<style lang="scss">
@import "../scss/base";
@import "../scss/components/splash";
</style>

<style lang="scss" scoped>
a:link,
a:visited {
  color: inherit;
}
/* Style the video: 100% width and height to cover the entire window */
#background-video {
  position: fixed;
  right: 0;
  bottom: 0;
  min-width: 100%;
  min-height: 100%;
}
</style>
